import React from 'react';

function components({ pedidos, criticos }) {
    return (
        <div className='row mr-1'>
            <div className='col-sm-6 d-flex flex-column justify-content-center align-items-center p-2' style={styles.blueCard}>
                <h1 style={styles.title}>{pedidos && pedidos}</h1>
                <span style={styles.description}>Pedidos</span>
            </div>
            <div className='col-sm-6 d-flex flex-column justify-content-center align-items-center p-2' style={styles.redCard}>
                <h1 style={styles.title}>{criticos && criticos}</h1>
                <span style={styles.description}>Críticos</span>
            </div>
        </div>
    );
}

const styles = {
    blueCard: {
        background: '#11446e',
        color: '#fff',
        borderTopLeftRadius: '5px',
        borderBottomLeftRadius: '5px',
    },
    redCard: {
        background: '#A72B2B',
        color: '#fff',
        borderTopRightRadius: '5px',
        borderBottomRightRadius: '5px',
    },
    title: {
        padding: 0,
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
        fontWeight: 'bold',
        fontSize: '27px',
    },
    description: {
        padding: 0,
        margin: 0,
        display: 'flex',
        justifyContent: 'center',
    },
};

export default components;
